const C = require("../constants");

const showFindClientModal = (data) => {
    return {
        type: C.FIND_CLIENT_MODAL,
        data
    }
};

export {showFindClientModal};


// WEBPACK FOOTER //
// ./src/actions/FindClientAction.js